module.exports = __webpack_public_path__ + "img/location.e039237c.svg";